import React from "react";
import { Chat } from "@/components/Chat";
import { NextPage } from "next";
import { useBot } from "@/api/useBot";
import { LoadingScreen } from "@/components/common/Loader/LoadingScreen";
import { NotFound } from "@/components/NotFound";

const ChatPage: NextPage<{ id: string }> = ({ id }) => {
  const { data, isLoading } = useBot(id);
  if (isLoading) {
    return <LoadingScreen />;
  }
  if (!data) {
    return <NotFound />;
  }
  return <Chat id={id} />;
};
ChatPage.getInitialProps = async (ctx) => {
  return { id: ctx.query.id as string };
};

export default ChatPage;
